export default __webpack_public_path__ + "static/logo-c557bb34fb179f880dffc07a30573d44.png";